import { useEffect, useState } from "react";
import Charts from "../Charts";
import { calculateCompoundInterest } from "../../../api";

const CompoundInterestChart = ({ idString }) => {
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      const values = idString?.split(",");
      if (!values || values.length < 5) return;

      const result = await calculateCompoundInterest(
        values[0],
        values[1],
        values[2],
        values[3],
        values[4]
      );

      const arrayOfObjects = Object.entries(result?.result?.details || {}).map(
        ([key, value]) => ({ id: key, ...value })
      );

      const newChartData = arrayOfObjects.map((el, index) => ({
        name: `Jahr ${index + 1}`,
        Eingezahlt: el?.paidIn,
        Zinsen: el?.interestIncome,
      }));

      setChartData(newChartData);
    };

    loadData();
  }, [idString]);

  if (!chartData) return <div>Lade Chart...</div>;

  return (
    <Charts.StackedBar
      className="article-chart"
      data={chartData}
      titleX="name"
      colors={[
        { key: "Eingezahlt", color: "#a938d3" },
        { key: "Zinsen", color: "#00ffcc" },
      ]}
      showTooltip
      tooltipValues={["Eingezahlt", "Zinsen"]}
      tooltipFooter={{ title: "Summe", values: ["Eingezahlt", "Zinsen"] }}
    />
  );
};

export default CompoundInterestChart;
